module.exports = __webpack_public_path__ + "img/hulai.528428ea.png";